
import {throwError as observableThrowError,  Observable } from 'rxjs';
/// <reference path="../typings.d.ts" />
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Token } from '../models/token';
import { TokenHelper } from '../shared/token_helper';
import { Config } from '../config';
import { User } from '../models/user';
import { OAuthResponse } from '../models/oauth_response';
import { environment } from "../../environments/environment";
import { AccountServiceMoc } from "./account.service.moc";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/timeout'
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/concat';

@Injectable()
export class Account {
	th: TokenHelper;
	errConn: string;
	userKey: string = 'user';
	timeout: number = 1000; //1 sec
	retry: number = 2; //max retry
	public dateNowFunc: any;
	delay: number = 3000; //max delay after retry

	constructor(private config: Config, private http: Http) {
		this.th = new TokenHelper();
		this.errConn = 'There is an error when communicating with a server, please try again later.';
		this.dateNowFunc = () => { return new Date() };
	}

	setToken(tk: Token) {
		this.th.setToken(this.config.tokenName, tk);
	}

	getUserProfileApi(): Observable<User> {
		var token = this.getToken();
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', token.tokenType + ' ' + token.accessToken);
		return this.http.get(this.config.authApiUrl + '/user/profile', { headers: headers })
			.timeout(this.timeout)
			.retryWhen(error => this.httpRetry(error))
			.map(resp => {
				if (resp.status == 200) {
					let data = resp.json()
					let us = new User();
					us.firstName = data.firstName;
					us.lastName = data.lastName;
					us.timeZone = data.timeZone;
					us.email = data.email;
					us.username = data.username;
					us.userId = data.userId;
					us.phoneNumber = data.phoneNumber;
					return us;
				} else {
					throw this.getError(resp);
				}
			})
			.catch((err) => {
				let er = this.getError(err);
				return observableThrowError(er);
			});
	}

	getUser(): User {
		if (localStorage.getItem(this.userKey) === null) {
			return null
		}
		return JSON.parse(localStorage.getItem(this.userKey));
	}

	setUser(user: User) {
		localStorage.setItem(this.userKey, JSON.stringify(user));
	}

	oauthLogin(ar: OAuthResponse) {
		ar.expiresAt = this.th.getExpiresAt(ar.expiresIn);
		this.th.setToken(this.config.tokenName, ar.getToken());
		return true;
	}

	getError(err: any): Error {
		var er: any;
		var msg = this.errConn;
		if (typeof (err.json) === 'function') {
			er = err.json();
			if (er.message != null && er.message != null && er.message != '') {
				msg = er.message;
			} else {
				console.log(err);
			}
			return new Error(msg);
		} else if (err instanceof Error) {
			return err;
		} else {
			console.log(err);
		}
	}

	getToken() {
		return this.th.getToken(this.config.tokenName);
	}

	logout() {
		window.location.href = this.config.logoutUrl();
	}

	removeLocalStorage() {
		localStorage.removeItem(this.userKey);
		this.th.removeToken(this.config.tokenName);
	}

	logoutWithMsg(msg: string) {
		this.th.removeToken(this.config.tokenName);
		window.location.href = this.config.loginUrl() + 'msg=' + encodeURI(msg);
	}

	httpRetry(o: Observable<any>): Observable<any> {
		return o
			.mergeMap((error, count) => {
				if (count < this.retry) {
					return Observable.of(error);
				}
				return observableThrowError(this.getError(error));
			})
			.delay(this.delay);
	}
}

export function validateToken(tokenName?: string, token?: Token) {
	var tname: string = tokenName || 'token';
	var t: Token;
	if (token) {
		t = token;
	} else {
		if (localStorage.getItem(tname) === null) {
			return false
		}
		let data = JSON.parse(localStorage.getItem(tname));
		t = new Token(data);
	}
	var tokenHelper = new TokenHelper();
	if (!t || tokenHelper.isTokenExpired(t)) {
		console.log('token is expired');
		return false
	} else {
		return true
	}
}

export function accountServiceFactory(
	config: Config,
	http: Http
) {
	return (environment.isMoc) ? new AccountServiceMoc(config, http) : new Account(config, http);
}
